import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';

interface ReportsTableState {
  currentPage: number;
  currentPageSize: number;
  pageSizes: number[];
}

const initialState: ReportsTableState = {
  currentPage: 1,
  currentPageSize: 50,
  pageSizes: [5, 10, 25, 50, 100]
};

const reportsTableSlice = createSlice({
  name: 'reportsTable',
  initialState,
  reducers: {
    onPreviousPage: (state) => {
      state.currentPage = state.currentPage - 1;
    },
    onNextPage: (state) => {
      state.currentPage = state.currentPage + 1;
    },
    onPageSizeChanged: (state, action: PayloadAction<number>) => {
      state.currentPageSize = action.payload;
      state.currentPage = 1;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const { actions, reducer } = reportsTableSlice;

export const { onPreviousPage, onNextPage, onPageSizeChanged } = actions;

export default reducer;

export const selectReportsTableState = (state: RootState) => state.reportsTable;
